import { useActivate } from 'app/components/activate/useActivate'
import { ActivateShadcnComponent } from 'app/components/activate/ActivateShadcnComponent'

export default function Activate() {
  const props = useActivate()
  return <ActivateShadcnComponent {...props} />
}
